/* Sponsors and partners strip: drifts on its own; swipe (touch) or drag (mouse) either way to flick through.
   The flick carries with momentum based on swipe speed, then eases straight back into the drift with no pause.
   Loops seamlessly (the list is doubled). */
(function () {
  [].forEach.call(document.querySelectorAll(".pt3__rail, [data-drift]"), function (rail) {
  var track = rail.querySelector("ul");
  if (!track) return;
  var items = track.children, n = items.length / 2, period = 0, x = 0, vel = 0, last = 0, idleUntil = 0, visible = true;
  var reduced = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches, speed = rail.hasAttribute("data-drift") ? 26 : 32;
  var measure = function () { period = items[n].offsetLeft - items[0].offsetLeft; };
  var paint = function () { if (period > 0) x = ((x % period) + period) % period; track.style.transform = "translate3d(" + (-x).toFixed(2) + "px,0,0)"; rail.dataset.x = x.toFixed(1); };
  var hold = function () { idleUntil = performance.now() + 2500; };
  measure(); paint();
  addEventListener("resize", function () { measure(); paint(); }); addEventListener("load", function () { measure(); paint(); });
  new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(rail);
  var pid = null, dragging = false, axis = "", sx = 0, sy = 0, x0 = 0, lx = 0, lt = 0, moved = 0;
  (function tick(t) {
    var dt = last ? Math.min(50, t - last) : 16; last = t;
    if (!period) measure();
    if (visible && !dragging && pid === null) {
      var drift = reduced ? 0 : speed / 1000;
      vel = drift + (vel - drift) * Math.pow(0.95, dt / 16);
      x += vel * dt;
      paint();
    }
    requestAnimationFrame(tick);
  })(0);
  rail.addEventListener("pointerdown", function (e) {
    pid = e.pointerId; sx = lx = e.clientX; sy = e.clientY; lt = performance.now(); x0 = x; axis = ""; moved = 0;
    vel = 0;
    if (e.pointerType === "mouse") { axis = "h"; dragging = true; rail.setPointerCapture(pid); rail.classList.add("is-drag"); }
  });
  rail.addEventListener("pointermove", function (e) {
    if (e.pointerId !== pid) return;
    var dx = e.clientX - sx, dy = e.clientY - sy;
    if (!axis && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) { axis = Math.abs(dx) > Math.abs(dy) ? "h" : "v"; if (axis === "h") { dragging = true; try { rail.setPointerCapture(pid); } catch (er) {} } }
    if (axis !== "h") return;
    moved = Math.max(moved, Math.abs(dx));
    var now = performance.now(), k = now - lt; if (k > 0) vel = 0.8 * vel + 0.2 * (-(e.clientX - lx) / k); lx = e.clientX; lt = now;
    x = x0 - dx; paint();
  });
  var end = function (e) {
    if (e.pointerId !== pid) return; pid = null;
    if (dragging) { dragging = false; rail.classList.remove("is-drag"); if (performance.now() - lt > 80) vel = reduced ? 0 : speed / 1000; vel = Math.max(-6, Math.min(6, vel)); }
  };
  rail.addEventListener("pointerup", end); rail.addEventListener("pointercancel", end);
  rail.addEventListener("wheel", function (e) { if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; e.preventDefault(); x += e.deltaX; paint(); }, { passive: false });
  rail.addEventListener("dragstart", function (e) { e.preventDefault(); });
  });
})();
